/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProviderComponentMetadata { 
    /**
     * Metadata key
     */
    key?: string;
    /**
     * Flag to indicate if it will be shown to tenant.
     */
    tenant_visible?: boolean;
    /**
     * Metadata value
     */
    value?: string;
}

